<template>
    <div class="like-wrapper" @click.prevent="onClick()">
        <i v-if="showIcon" :class="cssClasses"/>
        {{ text }}    
    </div>
</template>
<script>

import appProzis from '@/Utilities/app-prozis-store';
import browser from "@/Utilities/browser";
import request from "@/Utilities/httpRequest";
import baseUrl from "@/api/base-url";
import utilsHeader from '@/Utilities/desktop-header';
//import Favorites from '@/models/favorites-products';

export default {
    name: 'Like',
    emits: ['change'],
    props: {
        info: {
            // object with keys: itemId, type and liked
            type: Object
        },
        showIcon: {
            type: Boolean,
            default: true
        },
        showThumbIcon: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: null
        },
        currentUrl: {
            type: String
        },
        count:{
            type: Number,
            default: undefined
        },
        openInHeader: {
            type: Boolean,
            default: false
        },
    },
    data: () => {
        return {
            loading: false,
            //liked: false,
        }
    },
    computed: {
        liked() {
            return this.info.liked;
        },
        cssClasses() {
            if(this.showThumbIcon) {
                return this.liked ? 'prz-thumb-up-full' : 'prz-thumb-up-line';
            }
            
            return this.liked ? ['ecom-favourite-full prz-favorite-full', 'liked'] : ['ecom-favourite-line prz-favorite-line'];
        },
        // likeText(){
        //     const t = this.translations;
        //     if(this.liked && t && t.kLIKED){
        //         return t.kLIKED;
        //     }
        //     if(!this.liked && t && t.kLIKE){
        //         return t.kLIKE;
        //     }
        //     return null;
        // }
    },
    // watch: {

    // },
    // created(){
    //     //this.liked = this.info.liked;
    // },
    // mounted() {

    // },
    methods: {
        async onClick() {
            if(this.loading){
                // already making request
                return;
            }

            this.loading = true;
            this.$emit('request', true);

            // let type = this.info?.type??null;
            // if(type && type == 'PRODUCT'){
            //     Favorites.clearCache();
            // }

            const action = this.liked ? 'likes/remove' : 'likes/add';
            const params = {
                id: this.info.itemId,
                type: this.info.type,
                url: this.currentUrl ? this.currentUrl : (this.info.currentUrl ? this.info.currentUrl : document.location.href),
            };

            const {data} = await request.get(baseUrl.getUrl(action), params, false);
            if(data.redirect){
                document.location = data.redirect;
            }
            else if(data.doAuth){
                // desktop has tricky modal for login
                if(!this.openInHeader && typeof accountAuth !== 'undefined'){
                    // open login modal 
                    accountAuth.openLogin(data.urlParams);
                } else {
                    utilsHeader.sendHeaderEvent('evtOpenLogin', {open: true, params: data.urlParams});
                }
            }
            else{
                //this.liked = data.liked;
                if(action == 'likes/add'){
                    this.rtbHouse();
                }
                if(browser.isApp()){
                    let c = this.count != undefined ? this.count + (data.liked ? 1 : -1) : null;
                    appProzis.call('updateLike',JSON.stringify({
                        type: this.info.type,
                        id: this.info.itemId,
                        customerHasLike: data.liked,
                        count: c
                    }));
                }
                this.$emit('change', {itemId: this.info.itemId, liked: data.liked});
            }
            this.loading = false;
            this.$emit('request', false);
        },
        rtbHouse(){
            let rtbhEvents = window.rtbhEvents || [];
            const value = `${document.cookie}`;
            const parts = /__vh_ot\=([^;]*)/g.exec(value);
            rtbhEvents.push({
                eventType: 'wishlist',
                offerId: this.info.itemId
            }, {
                eventType: 'uid',
                id:  parts[1] ? parts[1] : null
            });
        },
    }
};
</script>